import { z } from 'zod';
import { ZodError } from 'zod';

export const envConfigSchema = z.object({
  api: z.url().optional(), // consoleApi
  qicApi: z.url(),
  acgrApi: z.url(),
  commonApi: z.url(),
  centeneApi: z.url(),
  pbrApi: z.url(),
  bulkEditApi: z.url(),
  freshdeskApi: z.url(),
  conceptApi: z.url(),
  insightsApi: z.url(),
  campaignsApi: z.url(),
  dfcApi: z.url(),
  graclApi: z.url(),
  outageNotificationsApi: z.url(),
  knowledgeManagementApi: z.url(),
  accessManagementApi: z.url(),
  reportingApi: z.url().optional(),
  outageNotificationsFallbackApi: z.url().optional(),
  casesApi: z.url().optional(),
  auth: z
    .object({
      region: z.string().optional(),
      userPoolId: z.string().optional(),
      userPoolWebClientId: z.string().optional(),
      oauth: z
        .object({
          domain: z.string().optional(),
          redirectSignIn: z.string().optional(),
          redirectSignOut: z.string().optional(),
          scope: z.array(z.string()).optional(),
          responseType: z.string().optional()
        })
        .optional()
    })
    .optional()
});

export type EnvConfig = z.infer<typeof envConfigSchema>;

export const parseEnvConfig = (rawConfig: unknown, configPath?: string): EnvConfig => {
  try {
    return envConfigSchema.parse(rawConfig);
  } catch (error) {
    if (error instanceof ZodError) {
      const missingFields = error.issues.map((issue) => `${issue.path.join('.')}: ${issue.message}`).join('\n');
      const configLocation = configPath || `src/configuration/${process.env.NODE_ENV || 'development'}.json`;
      throw new Error(
        `Invalid environment configuration. Missing or invalid fields:\n${missingFields}\n\n` +
          `Please check your configuration file at ${configLocation}`
      );
    }
    throw error;
  }
};
